import React from "react";
import { SmlLogo } from "../components/Logo";
// import { DATA, Product } from "../constants/data";

const VendorLinks = ({ url, label }: { url: string; label: string }) => {
  return (
    <a
      className="font-extrabold tracking-wider transition-colors text-gray-800 hover:text-blue-600"
      href={url}
      target="_blank"
    >
      {label}
    </a>
  );
};

const Vendors = () => {
  //   const BT60 = DATA[Product.BT60];
  return (
    <>
      <SmlLogo />
      <div
        className="h-screen gap-3 flex flex-col items-center justify-center"
        style={{ backgroundImage: "/images/60HS.png" }}
      >
        <VendorLinks
          url="https://mechboards.co.uk/search?q=bt*&type=product%2carticle%2cpage%2ccollection"
          label="Mechboards (UK)"
        />
        <VendorLinks
          url="https://keygem.store/search?q=bt&type=product"
          label="Keygem (DE)"
        />
        <VendorLinks
          url="https://www.upgradekeyboards.com/product-tag/polarity-works/"
          label="UpgradeKeyboards (USA)"
        />
        <VendorLinks
          url="https://www.eloquentclicks.com/product-tag/polarity-works/"
          label="EloquentClicks (ES)"
        />
        <VendorLinks
          url="https://rndkbd.com/collections/vendors?q=Polarity%20Works"
          label="RNDKBD (CA)"
        />
        <VendorLinks
          url="https://www.maxgaming.se/sv/plates-pcb-plates/bt60-v2-ansi-hotswap-tradlos"
          label="Max Gaming (SE)"
        />
      </div>
    </>
  );
};
export default Vendors;
